<template>
  <page-list
    :list="list"
    :columns="columns"
    :single-actions="singleActions"
    :group-actions="groupActions"
    :export-data-options="exportDataOptions" />
</template>

<script>
import * as R from 'ramda'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
// import {
//   getNameFilter,
//   getCreatedAtFilter,
// } from '@/utils/common/tableFilter'

export default {
  name: 'ResourceTypeSettingList',
  mixins: [WindowsMixin, ListMixin],
  props: {
    id: String,
    getParams: Function || Object,
    data: Object,
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'ext_resource_types',
        apiVersion: 'v1',
        getParams: this.getParam,
        // filterOptions: {
        //   name: getNameFilter({ field: 'name', label: this.$t('table.title.name') }),
        //   created_at: getCreatedAtFilter(),
        // },
        hiddenColumns: [],
      }),
      groupActions: [
        {
          label: this.$t('common.action.create'),
          permission: 'report_settings_create',
          action: () => {
            this.createDialog('ResourceTypeAssociateDialog', {
              originResourceType: this.data,
              ok: () => {
                this.$bus.$emit('updateResourceTypeParent', this.data.id)
              },
            })
          },
          meta: () => {
            const ret = {
              validate: true,
              buttonType: 'primary',
            }
            if (this.data.parent_id) {
              ret.validate = false
            }
            return ret
          },
        },
        // {
        //   label: this.$t('common.action.delete'),
        //   permission: 'report_settings_delete',
        //   action: () => {
        //     this.createDialog('DeleteResDialog', {
        //       name: this.$t('report.report_setting'),
        //       title: this.$t('common.action.delete'),
        //       vm: this,
        //       data: this.list.selectedItems,
        //       columns: this.columns,
        //       onManager: this.onManager,
        //     })
        //   },
        //   meta: () => {
        //     const ret = { validate: !!this.list.selectedItems.length }
        //     return ret
        //   },
        // },
      ],
      singleActions: [
        {
          label: this.$t('table.action.modify'),
          permission: 'report_settings_perform_add_elements',
          action: () => {
            this.createDialog('ResourceTypeAssociateDialog', {
              originResourceType: this.data,
              type: 'edit',
              ok: () => {
                this.$bus.$emit('updateResourceTypeParent', this.data.id)
              },
            })
          },
        },
        {
          label: this.$t('common.action.delete'),
          permission: 'report_settings_delete',
          action: (obj) => {
            this.createDialog('DeleteResDialog', {
              name: this.$t('report.report_setting'),
              title: this.$t('common.action.delete'),
              vm: this,
              data: [obj],
              columns: this.columns,
              ok: () => {
                this.deleteParent()
              },
            })
          },
        },
      ],
      columns: [
        {
          field: 'origin_name',
          title: this.$t('report.origin_resource_type'),
          formatter: ({ row }) => {
            return this.data.name
          },
        },
        {
          field: 'name',
          title: this.$t('report.parent_resource_type'),
          formatter: ({ row }) => {
            return row.name
          },
        },
      ],
    }
  },
  computed: {
    exportDataOptions () {
      return {
        downloadType: 'local',
        items: this.columns || [],
      }
    },
  },
  watch: {
    'getParams.id': {
      handler (val) {
        this.list.refresh()
      },
    },
  },
  created () {
    this.fetchData()
  },
  methods: {
    getParam () {
      let ret = {
        $t: new Date().getTime(),
      }
      if (this.getParams) {
        ret = {
          ...ret,
          ...(R.is(Function, this.getParams) ? this.getParams() : this.getParams),
        }
      }

      return ret
    },
    fetchData () {
      this.list.fetchData()
    },
    async deleteParent () {
      try {
        await new this.$Manager('ext_resource_types', 'v1').update({
          id: this.data.id,
          data: { parent_id: '' },
        })
        this.$bus.$emit('updateResourceTypeParent', this.data.id)
      } catch (error) {
        throw error
      }
    },
  },
}
</script>
